/**
 * Sidebar Toggle — Responsive sidebar for mobile/tablet
 *
 * Gère l'ouverture/fermeture de la sidebar sur mobile via le bouton hamburger.
 * La sidebar utilise un transform CSS (translateX) géré par la classe .show.
 * Un backdrop s'affiche derrière la sidebar pour permettre de la fermer.
 *
 * Ne s'exécute que si les éléments #sidebarToggle et #extranetSidebar existent
 * (pages protégées uniquement).
 */
const sidebarToggle = {
  init() {
    const toggle = document.getElementById('sidebarToggle');
    const sidebar = document.getElementById('extranetSidebar');
    const backdrop = document.getElementById('sidebarBackdrop');

    if (!toggle || !sidebar) return;

    const open = () => {
      sidebar.classList.add('show');
      if (backdrop) backdrop.classList.add('show');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sidebar-open');
    };

    const close = () => {
      sidebar.classList.remove('show');
      if (backdrop) backdrop.classList.remove('show');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sidebar-open');
    };

    // Toggle on hamburger click
    toggle.addEventListener('click', () => {
      sidebar.classList.contains('show') ? close() : open();
    });

    // Close on backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', close);
    }

    // Close on nav link click (mobile UX)
    sidebar.querySelectorAll('.nav-link').forEach((link) => {
      link.addEventListener('click', close);
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sidebar.classList.contains('show')) {
        close();
      }
    });
  }
};

export default sidebarToggle;
